export default __webpack_public_path__ + "static/media/weight-gray.9f5a56b9.svg";